export const getCountryCode = str => {
  if (str && !str.includes('+')) {
    return `+${str}`;
  }
  return str;
};

export default { getCountryCode };
